import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { AnnouncementBar } from "@/components/site/AnnouncementBar";
import { ScrollProgress } from "@/components/site/ScrollProgress";
import { FloatingStamp } from "@/components/site/FloatingStamp";
import { GrainOverlay } from "@/components/site/GrainOverlay";
import { Toaster } from "@/components/ui/toaster";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Services from "@/pages/Services";
import Privacy from "@/pages/Privacy";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Layout() {
  return (
    <LanguageProvider>
      <ScrollToTop />
      <GrainOverlay />
      <ScrollProgress />
      <div className="fixed top-0 left-0 w-full z-50">
        <AnnouncementBar />
        <Header />
      </div>
      <main>
        <Outlet />
      </main>
      <FloatingStamp />
      <Footer />
      <Toaster />
    </LanguageProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/sobre" element={<About />} />
            <Route path="/contacto" element={<Contact />} />
            <Route path="/servicios" element={<Services />} />
            <Route path="/privacidad" element={<Privacy />} />
            <Route path="/en" element={<Home />} />
            <Route path="/en/about" element={<About />} />
            <Route path="/en/contact" element={<Contact />} />
            <Route path="/en/services" element={<Services />} />
            <Route path="/en/privacy" element={<Privacy />} />
          </Route>
        </Routes>
      </SmoothScroll>
    </BrowserRouter>
  );
}

export default App;
